import { useAuthStore } from '@/core/store/auth/authStore';

import { client } from '../apolloClient';

import { callRefreshTokenMutation } from './callRefreshTokenMutation';

let isRefreshing = false;
let refreshPromise: Promise<boolean> | null = null;

/**
 * Only refresh the token once, no matter how many requests fail in parallel.
 * Returns true if token was successfully refreshed, false otherwise.
 */
export const singleIdTokenRefresh = async (): Promise<boolean> => {
	const username = useAuthStore.getState().authUsername;
	const setIdToken = useAuthStore.getState().setIdToken;
	const resetAuthStore = useAuthStore.getState().resetStore;

	if (isRefreshing && refreshPromise) {
		return refreshPromise;
	}

	isRefreshing = true;
	refreshPromise = (async () => {
		try {
			const res = await callRefreshTokenMutation(client, username);
			const responseBody = res.data?.signIn;

			if (responseBody?.__typename === 'SignInResult' && responseBody.idToken) {
				setIdToken(responseBody.idToken);

				return true;
			} else {
				resetAuthStore();
				await client.clearStore();

				return false;
			}
		} catch (_) {
			resetAuthStore();
			await client.clearStore();

			return false;
		} finally {
			isRefreshing = false;
			refreshPromise = null;
		}
	})();

	return refreshPromise;
};
